import { InjectionToken } from '@angular/core';

export const windowToken = new InjectionToken('Window');
export const windowProvider = () => window;
